module.exports = __webpack_public_path__ + "static/media/assist.fc12d948.svg";